import {
  TFetchAvailableShippingMethodsRequestBody,
  TFetchProductsQuery,
} from "src/data/ecommerce/ecommerceTypes"

export const queryKeys = {
  all() {
    return ["ecommerce"] as const
  },

  shippingDestinations() {
    return [...this.all(), "shippingDestinations"] as const
  },

  products(filter: TFetchProductsQuery, userId?: string) {
    if (userId) {
      return [...this.all(), "products", userId, filter] as const
    }

    return [...this.all(), "products", filter] as const
  },

  shippingMethods(body: TFetchAvailableShippingMethodsRequestBody) {
    return [...this.all(), "shippingMethods", body] as const
  },

  warehouses() {
    return [...this.all(), "warehouses"] as const
  },
} as const
